<div class="app-main__inner">

  <!-- ========== LIST VIEW ========== -->
  <div *ngIf="view === 'list'" class="bb-list-view">
    <div class="card bb-fill-card">
      <div class="card-header d-flex align-items-center justify-content-between">
        <span class="fw-semibold"><i class="pe-7s-global me-2 text-primary"></i>Languages List</span>
        <div class="d-flex align-items-center gap-2">
          <span class="badge bg-secondary">{{ records.length }} records</span>
          <button type="button" class="btn btn-primary btn-sm" (click)="addNew()">
            <i class="pe-7s-plus me-1"></i> Add New Language
          </button>
        </div>
      </div>
      <div class="card-body p-0 bb-fill-body">
        <div class="text-center py-5" *ngIf="isListLoading">
          <div class="spinner-border text-primary"></div>
          <p class="mt-2 text-muted">Loading languages...</p>
        </div>
        <vio-table-v2 *ngIf="!isListLoading" [tableData]="records" [tableConfig]="tableConfig"></vio-table-v2>
      </div>
    </div>
  </div>

  <!-- ========== FORM VIEW ========== -->
  <div *ngIf="view === 'form'" class="bb-form-view">
    <div class="bb-form-card">

      <div class="bb-form-header">
        <div class="bb-form-header__title">
          <i class="pe-7s-global"></i>
          {{ isEditMode ? 'Edit Language' : 'New Language' }}
        </div>
        <button type="button" class="bb-form-header__back" (click)="backToList()">
          <i class="pe-7s-angle-left"></i> Back
        </button>
      </div>

      <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
        <div class="bb-form-body">
          <div class="row g-2">
            <div class="col-md-5">
              <label class="form-label">Language Name <span class="text-danger">*</span></label>
              <input type="text" formControlName="languageName" class="form-control"
                     [class.is-invalid]="isFieldInvalid('languageName')"
                     placeholder="e.g. English, Hindi, Marathi" />
              <div class="invalid-feedback">
                <span *ngIf="f['languageName'].errors?.['required']">Language name is required.</span>
                <span *ngIf="f['languageName'].errors?.['minlength']">Must be at least 2 characters.</span>
              </div>
            </div>
            <div class="col-md-3">
              <label class="form-label">Language Code <span class="text-danger">*</span></label>
              <input type="text" formControlName="code" class="form-control"
                     [class.is-invalid]="isFieldInvalid('code')"
                     placeholder="e.g. EN, HI, MR" maxlength="5"
                     (input)="onCodeInput($event)" />
              <div class="invalid-feedback">
                <span *ngIf="f['code'].errors?.['required']">Code is required.</span>
                <span *ngIf="f['code'].errors?.['invalidCode']">2–5 alphabetic characters.</span>
              </div>
              <div class="form-text">ISO 639 code. Auto-uppercased.</div>
            </div>
          </div>
        </div>

        <div class="bb-form-footer">
          <div class="bb-form-footer__msg">
            <span *ngIf="errorMessage" class="text-danger"><i class="pe-7s-close-circle me-1"></i>{{ errorMessage }}</span>
            <span *ngIf="successMessage" class="text-success"><i class="pe-7s-check me-1"></i>{{ successMessage }}</span>
          </div>
          <button type="submit" class="bb-btn-save" [disabled]="isSaving">
            <span *ngIf="!isSaving"><i class="pe-7s-diskette"></i> {{ isEditMode ? 'Update' : 'Save' }}</span>
            <span *ngIf="isSaving" class="d-flex align-items-center gap-1"><span class="spinner-border spinner-border-sm"></span> Saving...</span>
          </button>
        </div>
      </form>

    </div>
  </div>

</div>
